class NotificationBar extends HTMLElement {
  connectedCallback() {
    this.initVariables();
    this.dismissNotification = this.dismissNotification.bind(this);
    this.showIfNotDismissed();
    this.addDismissListener();
  }

  initVariables() {
    this.sectionId = this.getAttribute('section-id');
    this.storageKey = 'pxl:notification-bar:dismissed';
  }

  /**
   * Shows the notification bar if it has not been dismissed.
   * @returns {void}
   */
  showIfNotDismissed() {
    if (this.hasBeenDismissed) return;
    this.classList.remove('hidden');
  }

  /**
   * Adds a click event listener to the close button.
   * @returns {void}
   */
  addDismissListener() {
    this.querySelector('[data-close-notification]').addEventListener(
      'click',
      this.dismissNotification
    );
  }

  /**
   * Dismisses the notification bar. Adds the section ID to the session storage.
   */
  dismissNotification() {
    this.classList.add('hidden');

    const sessionValue = sessionStorage.getItem(this.storageKey) ?? '';
    const dismissedSections = new Set(sessionValue.split('|').filter(Boolean));
    dismissedSections.add(this.sectionId);
    sessionStorage.setItem(this.storageKey, [...dismissedSections].join('|'));
  }

  /**
   * Returns whether the notification bar has been dismissed.
   * @returns {boolean}
   */
  get hasBeenDismissed() {
    const sessionValue = sessionStorage.getItem(this.storageKey);

    if (!sessionValue) return false;

    return sessionValue.includes(this.sectionId);
  }
}

customElements.define('notification-bar', NotificationBar);
